<template>
    <div class="flex flex-col">
        <div class="relative z-0 w-full px-10">
            <div class="absolute inset-x-0 top-0 z-0 bg-wecare-red" style="height: 400px;"></div>

            <div class="relative z-10 flex flex-col flex-1 w-full mx-auto bg-white border border-gray-600 my-12 p-10 login-form bg-login-form rounded-lg" style="max-width: 900px; border-color: rgb(216, 221, 228);">
                <form class="flex flex-col w-full mx-auto text-center" style="max-width: 532px;" @submit.prevent="submitForm">    
                    <img src="@/assets/img/nav/account.svg" class="w-auto hidden sm:block sm:h-24" />
                    <span class="mb-5 font-bold text-2xl md:text-4xl" style="margin-top: 0.4rem;">Se <span class="text-wecare-red">connecter</span></span>

                    <span class="mb-4 text-lg font-bold text-wecare-red" v-if="!message && $route.query.session == 'expired'">Session expirée. Veuillez vous reconnecter.</span>
                    <span class="mb-4 text-lg font-bold text-wecare-red" v-if="message && !errors">Adhésion introuvable</span>

                    <aff-input v-model="number" label="Numéro d'adhérent *" placeholder="X12345678" type="text" :errors="errors && errors.number ? errors.number : null" class="relative w-full"/>
                    <span class="text-xs text-left mb-4 -mt-3">Si vous bénéficiez d’une garantie Next Mobiles, le numéro d’adhérent est le numéro d’IMEI de votre téléphone.</span>

                    <aff-input v-model="email" label="Votre e-mail *" placeholder="E-mail" type="text" :errors="errors && errors.email ? errors.email : null" class="relative w-full"/>
                    
                    <span class="relative flex items-center mb-4 mr-auto -mt-2 cursor-pointer">
                        <input type="checkbox" id="remember_me" class="-mt-1"/>
                        <label for="remember_me" class="text-sm md:text-base ml-2 text-gray-600 cursor-pointer">Se souvenir de moi</label>    
                    </span>

                    <input type="submit" class="btn h-20 cursor-pointer border border-wecare-red bg-wecare-red hover:scale-105 hover:bg-white hover:text-wecare-red" value="Je me connecte" v-if="!isLoading" />

                    <span class="btn h-20 bg-wecare-red cursor-wait" v-else>
                        <svg version="1.1" class="text-white fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                            <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                                <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                            </path>
                        </svg>
                    </span>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import AffInput from '@/components/forms/Input'
import { handleLogin } from '@/auth'

export default {
    components: { AffInput },
    data: function () {
        return {
            number: null,
            email: null,
            isLoading: false,
            errors: null,
            message: null
        }
    },
    methods: {
        submitForm: function () {
            this.isLoading = true

            handleLogin(this.number, this.email)
            .then(({data}) => {
                this.$router.push('client')
            },
            (loginResponse) => {
                this.errors = loginResponse.response.data.errors
                this.message = loginResponse.message
                this.isLoading = false
            })

            /*
            let payload = {
                email: this.email,
                number: this.number,
                contract: 'wecare_plus'
            }
            
            this.$http.post('/login', payload).then(({data}) => {
                sessionStorage.access_token = data.bearer
                this.$root.subscription = data.subscription
                
                this.$router.push('client')
            }, error => {
                this.errors = error.response.data.errors
                this.message = error.response.data.message
                this.isLoading = false
            })
            */
        }
    }
}
</script>